import { render, staticRenderFns } from "./activityedit.vue?vue&type=template&id=4138ba40&scoped=true"
import script from "./activityedit.vue?vue&type=script&lang=js"
export * from "./activityedit.vue?vue&type=script&lang=js"
import style0 from "./activityedit.vue?vue&type=style&index=0&id=4138ba40&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4138ba40",
  null
  
)

export default component.exports